export default data => async (dispatch, getState, { api, schema }) => {
  try {
    const res = await api.berbix.berbixSaveTransaction(data);
    return res;
  } catch (e) {
    return {};
  }
};
